import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferCityName, InvestmentOfferCitySlug, InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const gdansk = require("../images/cities/gdansk.jpg");
const krakow = require("../images/cities/krakow.jpg");
const lodz = require("../images/cities/lodz.jpg");
const poznan = require("../images/cities/poznan.jpg");
const warszawa = require("../images/cities/warszawa.jpg");
const wroclaw = require("../images/cities/wroclaw.jpg");

const getInvestmentOfferCityHref = (citySlug: InvestmentOfferCitySlug) => {
    return rpAppLink.investmentOffer.investmentCategory.subcategory.base({
        category: InvestmentOfferTypeSlug.INVESTMENT,
        subcategory: citySlug
    });
};

export const useInvestmentOfferCities = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const regionStats = useSelector((state: IRPStore) => state.investmentOffer.stats.by_region);

    return [
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.WARSZAWA),
            offersCount: regionStats["8647"].is_investment_apartment,
            image: warszawa,
            title: InvestmentOfferCityName.WARSZAWA
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.POZNAN),
            offersCount: regionStats["30892"].is_investment_apartment,
            image: poznan,
            title: InvestmentOfferCityName.POZNAN
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.WROCLAW),
            offersCount: regionStats["26955"].is_investment_apartment,
            image: wroclaw,
            title: InvestmentOfferCityName.WROCLAW
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.KRAKOW),
            offersCount: regionStats["11158"].is_investment_apartment,
            image: krakow,
            title: InvestmentOfferCityName.KRAKOW
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.GDANSK),
            offersCount: regionStats["46083"].is_investment_apartment,
            image: gdansk,
            title: InvestmentOfferCityName.GDANSK
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.LODZ),
            offersCount: regionStats["16187"].is_investment_apartment,
            image: lodz,
            title: InvestmentOfferCityName.LODZ
        }
    ];
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferCityName, InvestmentOfferCitySlug, InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const gdansk = require("../images/cities/gdansk.jpg");
const krakow = require("../images/cities/krakow.jpg");
const lodz = require("../images/cities/lodz.jpg");
const poznan = require("../images/cities/poznan.jpg");
const warszawa = require("../images/cities/warszawa.jpg");
const wroclaw = require("../images/cities/wroclaw.jpg");

const getInvestmentOfferCityHref = (citySlug: InvestmentOfferCitySlug) => {
    return rpAppLink.investmentOffer.investmentCategory.subcategory.base({
        category: InvestmentOfferTypeSlug.INVESTMENT,
        subcategory: citySlug
    });
};

export const useInvestmentOfferCities = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const regionStats = useSelector((state: IRPStore) => state.investmentOffer.stats.by_region);

    return [
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.WARSZAWA),
            offersCount: regionStats["8647"].is_investment_apartment,
            image: warszawa,
            title: InvestmentOfferCityName.WARSZAWA
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.POZNAN),
            offersCount: regionStats["30892"].is_investment_apartment,
            image: poznan,
            title: InvestmentOfferCityName.POZNAN
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.WROCLAW),
            offersCount: regionStats["26955"].is_investment_apartment,
            image: wroclaw,
            title: InvestmentOfferCityName.WROCLAW
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.KRAKOW),
            offersCount: regionStats["11158"].is_investment_apartment,
            image: krakow,
            title: InvestmentOfferCityName.KRAKOW
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.GDANSK),
            offersCount: regionStats["46083"].is_investment_apartment,
            image: gdansk,
            title: InvestmentOfferCityName.GDANSK
        },
        {
            href: getInvestmentOfferCityHref(InvestmentOfferCitySlug.LODZ),
            offersCount: regionStats["16187"].is_investment_apartment,
            image: lodz,
            title: InvestmentOfferCityName.LODZ
        }
    ];
};
